import React from 'react';
import $ from 'jquery';
import {
    facebookShareLink,
    twitterShareLink,
    whatsappShareLink,
    DOMAINE_URL,
} from '../Utils/bootstrap'

const SharePopup = (props) => {
    let link = props.link;
    let baseurl = DOMAINE_URL;
    var facebookLink = `${facebookShareLink}&link=${encodeURIComponent(baseurl)}&quote=${link}&www.facebook.com=1`
    var twitterLink = `${twitterShareLink} ${encodeURIComponent(baseurl + "\n\n" + link)}&www.facebook.com=1`
    var whatsappLink = `${whatsappShareLink} ${encodeURIComponent(baseurl + "\n\n" + link)}&www.facebook.com=1`

    return (
        <div className="popup_fixed_bg" id="share_popup_box_main" style={{ display: "none" }}>

            <div className="popup_bg">
                <h3 className="share_popup_h4">Share
                    <a
                        href="javascript:void(0);"
                        onClick={() => {
                            $(".popup_fixed_bg").hide();
                        }}
                        className="crossbtnshare"
                    >
                        <span className="fa fa-times"></span>
                    </a>
                </h3>
                <ul className="d-flex justify-content-center align-items-center">
                    <li>
                        <figure>
                            <a href={facebookLink} target="_blank" rel="noopener noreferrer">
                                <img
                                    src="/assets/images/facebook.svg"
                                    className="share_icons"
                                />
                                <figcaption>{"Facebook"}</figcaption>
                            </a>
                        </figure>
                    </li>

                    <li>
                        <figure>
                            <a href={twitterLink} target="_blank" rel="noopener noreferrer">
                                <img
                                    src="/assets/images/twitter.svg"
                                    className="share_icons"
                                />
                                <figcaption>{"Twitter"}</figcaption>
                            </a>
                        </figure>
                    </li>
                    <li>
                        <figure>
                            <a href={whatsappLink} target="_blank" rel="noopener noreferrer">
                                <img
                                    src="/assets/images/whatsapp.svg"
                                    className="share_icons"
                                />
                                <figcaption>{"Whatsapp"}</figcaption>
                            </a>
                        </figure>
                    </li>
                </ul>
            </div>
        </div>


    )
}
export default SharePopup;